import React from "react";
import { Para } from "@irati/ui/src/Labels";
import { FormattedMessage } from "@irati/utils/lang";
import { PlaceholderIcon } from "./styled";
import { ViewType } from "../helpers";
var chartTypeRadioOptions = [
    {
        customNode: (React.createElement(React.Fragment, null,
            React.createElement(PlaceholderIcon, null),
            React.createElement(Para, { flush: true },
                React.createElement(FormattedMessage, { id: "admin.reportingV3.segmentAndFilter.graphToggle" })))),
        value: ViewType.GRAPH
    },
    {
        customNode: (React.createElement(React.Fragment, null,
            React.createElement(PlaceholderIcon, null),
            React.createElement(Para, { flush: true },
                React.createElement(FormattedMessage, { id: "admin.reportingV3.segmentAndFilter.tableToggle" })))),
        value: ViewType.TABLE
    }
];
export default chartTypeRadioOptions;
